import { PACKAGE_NAMES } from "@/i18n/translations";
import { trackClick } from "./track";

// Visitor-facing entry points, not new products or price tiers.
export const BUSINESS_PATHS = [
  { key: "spreadsheets", serviceId: "service-spreadsheets", packageName: PACKAGE_NAMES[1] },
  { key: "automation", serviceId: "service-automation", packageName: PACKAGE_NAMES[2] },
  { key: "overview", serviceId: "service-overview", packageName: PACKAGE_NAMES[3] },
];

export const SERVICE_PATH_KEYS = ["spreadsheets", "automation", null, "overview"];

export const inquireAboutPath = (key) => {
  const path = BUSINESS_PATHS.find((item) => item.key === key);
  if (path) window.dispatchEvent(new CustomEvent("ph:select-package", { detail: path.packageName }));
  trackClick("contact");
};